import {
  ArrowDownIcon,
  ArrowUpIcon,
  CaretSortIcon,
} from "@radix-ui/react-icons";
import { cn } from "@/lib/utils";

interface DataTableSortArrowProps {
  sortDirection: false | "asc" | "desc";
  className?: string;
}

export function DataTableSortArrow({
  sortDirection,
  className,
}: DataTableSortArrowProps) {
  if (sortDirection === "desc") {
    return (
      <ArrowDownIcon
        className={cn("ml-2 h-4 w-4 text-foreground", className)}
      />
    );
  }

  if (sortDirection === "asc") {
    return (
      <ArrowUpIcon className={cn("ml-2 h-4 w-4 text-foreground", className)} />
    );
  }

  return (
    <CaretSortIcon
      className={cn(
        "ml-2 h-4 w-4 text-muted-foreground/50 transition-colors group-hover:text-muted-foreground/80",
        className,
      )}
    />
  );
}
